<template>
  <div>
    <yx-auto-complete
      :width="width"
      :api="customApi || api.getCourseList"
      :placeholder="placeholder"
      :immediate="immediate"
      :keys="{ searchKey: 'curriculumName', nameKey: 'curriculumName' }"
      :query-params="queryParams"
      :disabled="disabled"
      @select="(arg) => $emit('select', arg)"
      @clear="() => $emit('clear')"
      ref="yxRef"
    />
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
  props: {
    width: {
      type: String,
      default: '320px',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    queryParams: Object,
    customApi: {},
    disabled: Boolean,
    immediate: {
      type: Boolean,
      default: true,
    }, // 是否获取焦点立即查询
  },
  setup() {
    const yxRef = ref(null);
    return {
      yxRef,
      clearField() {
        yxRef.value.clearField();
      },
      setField(str) {
        yxRef.value.setField(str);
      },
    };
  },
});
</script>
